import httpClient from '@utils/httpClient.js';

// Niche presets (static catalog, not profile-scoped)
export const getNichePresets = () => httpClient.get(`api/content-strategies/niche-presets`);

// Strategy CRUD
export const listStrategies = (profileId) => httpClient.get(`api/profiles/${profileId}/content-strategies`);

export const createStrategy = (profileId, data) => httpClient.post(`api/profiles/${profileId}/content-strategies`, data);

export const updateStrategy = (strategyId, data) => httpClient.put(`api/content-strategies/${strategyId}`, data);

export const deleteStrategy = (strategyId) => httpClient.delete(`api/content-strategies/${strategyId}`);

// Idea generation + lifecycle
export const generateIdeas = (strategyId, data) =>
  httpClient.post(`api/content-strategies/${strategyId}/generate-ideas`, data);

export const listIdeas = (strategyId, status) =>
  httpClient.get(`api/content-strategies/${strategyId}/ideas`, { params: status ? { status } : {} });

export const approveIdea = (ideaId) => httpClient.patch(`api/content-ideas/${ideaId}/approve`);

export const skipIdea = (ideaId) => httpClient.patch(`api/content-ideas/${ideaId}/skip`);

export const updateIdea = (ideaId, data) => httpClient.patch(`api/content-ideas/${ideaId}`, data);
